/**
 * Tracking utility — Meta Pixel + Google Ads + WhatsApp events
 */

// Meta Pixel events
export const trackLead = (data = {}) => {
  if (window.fbq) window.fbq('track', 'Lead', data);
  if (window.gtag) window.gtag('event', 'generate_lead', data);
};

export const trackViewContent = (data = {}) => {
  if (window.fbq) window.fbq('track', 'ViewContent', data);
};

export const trackInitiateCheckout = (data = {}) => {
  if (window.fbq) window.fbq('track', 'InitiateCheckout', data);
  if (window.gtag) window.gtag('event', 'begin_checkout', data);
};

export const trackPurchase = (data = {}) => {
  if (window.fbq) window.fbq('track', 'Purchase', data);
  if (window.gtag) window.gtag('event', 'purchase', data);
};

export const trackContact = (method = 'whatsapp') => {
  if (window.fbq) window.fbq('track', 'Contact', { method });
  if (window.gtag) window.gtag('event', 'contact', { method });
};

export const trackSchedule = (data = {}) => {
  if (window.fbq) window.fbq('track', 'Schedule', data);
  if (window.gtag) window.gtag('event', 'schedule', data);
};
